define([
    'lodash/object/assign',
    'lodash/lang/isEqual',
    'lodash/lang/clone',
    'component-emitter'
], function (assign, isEqual, clone, Emitter) {
    'use strict';

    var BaseModel = function () {};
    assign(BaseModel.prototype, Emitter.prototype);
    assign(BaseModel.prototype, {

        attrs: {},
        _previousAttrs: {},

        set: function (key, val, force) {
            var previousAttrs = clone(this.attrs);

            if (typeof key === 'object') {
                assign(this.attrs, key);
                force = val;
            } else {
                this.attrs[key] = val;
            }

            if (force === true || !isEqual(previousAttrs, this.attrs)) {
                this._previousAttrs = previousAttrs;
                this.emit('change');
            }
        },

        isChanged: function (key) {
            if (isEqual(this.prev(key), this.get(key))) {
                return false;
            }
            return true;
        },

        get: function (key) {
            return this.attrs[key];
        },

        prev: function (key) {
            return this._previousAttrs[key];
        }
    });

    return {
        BaseModel: BaseModel
    };
});



/** WEBPACK FOOTER **
 ** ./js/model/BaseModel.js
 **/